import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Outlet, } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import verifyToken from 'services/store/features/roles/actions';
import Navigation from 'components/Navigation';
import Loading from 'components/library/Loading';
var Onboarding = React.lazy(function () { return import('views/Onboarding'); });
var Overview = React.lazy(function () { return import('views/Overview'); });
var Society = React.lazy(function () { return import('views/Society'); });
var Person = React.lazy(function () { return import('views/Person'); });
var SocietyKyc = React.lazy(function () { return import('views/Society/SocietyKyc'); });
var Invoices = React.lazy(function () { return import('views/Invoices'); });
var ROUTES = [
    {
        path: '/onboarding/:type/:id',
        component: function () { return _jsx(Onboarding, {}); },
    },
    {
        path: '/onboarding/:type',
        component: function () { return _jsx(Onboarding, {}); },
    },
    {
        path: '/society/:id',
        component: function () { return _jsx(SocietyKyc, {}); },
    },
    {
        path: '/society',
        component: function () { return _jsx(Society, {}); },
    },
    {
        path: '/person',
        component: function () { return _jsx(Person, {}); },
    },
    {
        path: '/invoices',
        component: function () { return _jsx(Invoices, {}); },
    },
    {
        path: '/',
        component: function () { return _jsx(Overview, {}); },
    },
];
function ProtectedRoute(_a) {
    var status = _a.status, roles = _a.roles, authorizedRole = _a.authorizedRole;
    var _b = useState(false), showRoute = _b[0], setShowRoute = _b[1];
    var navigate = useNavigate();
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(verifyToken());
    }, []);
    useEffect(function () {
        if (roles && roles.length > 0 && status === 'SUCCEEDED') {
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, roles_1 = roles; _i < roles_1.length; _i++) {
                var role = roles_1[_i];
                if (!authorizedRole.includes(role)) {
                    if (window.history.length === 1) {
                        document.location.assign("https//".concat(process.env.REACT_APP_DEBUG ? 'dev-' : '', "auth.ayomi.fr/"));
                    }
                    else {
                        navigate(-1);
                    }
                }
                else {
                    setShowRoute(true);
                }
            }
        }
        else {
            setShowRoute(true);
        }
    }, [status]);
    if (status === 'SUCCEEDED' && showRoute) {
        return (_jsx(Outlet, {}));
    }
    return _jsx(Loading, {});
}
var mapStateToProps = function (state) { return ({
    authorizedRole: state.roles.roles,
    status: state.roles.status,
}); };
var ConnectedProtectedRoute = connect(mapStateToProps)(ProtectedRoute);
function RouteView(_a) {
    var route = _a.route;
    return (_jsxs(_Fragment, { children: [(!route.path.includes('onboarding'))
                && (_jsx(Navigation, {})), _jsx("div", { className: "".concat(!route.path.includes('onboarding') ? 'main-content' : 'full'), children: _jsx(route.component, {}) })] }));
}
export default function RouteConfig() {
    return (_jsx(Router, { children: _jsx(Suspense, { fallback: _jsx(Loading, {}), children: _jsx(Routes, { children: _jsx(Route, { element: _jsx(ConnectedProtectedRoute, { roles: [] }), children: ROUTES.map(function (route) { return (_jsx(Route, { path: route.path, element: _jsx(RouteView, { route: route }) }, route.path)); }) }) }) }) }));
}
